import * as React from "react";
const SvgFiRrNoodles = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-noodles_svg__a)">
      <path
        fill="#062147"
        d="M24 6a1 1 0 0 1-1 1H12.456c-.315.451-.71 1.032-.29 1.555a4.01 4.01 0 0 1 0 4.89.94.94 0 0 0 0 1.11 4.01 4.01 0 0 1 0 4.89.94.94 0 0 0 0 1.11c.705.89 1.56 3.246-.166 3.445-1.329-.037-.758-1.509-1.416-2.222a2.945 2.945 0 0 1 0-3.557 2 2 0 0 0 0-2.443 2.945 2.945 0 0 1 0-3.557 2 2 0 0 0 0-2.443A2.94 2.94 0 0 1 10.164 7H8.472c-.316.452-.71 1.031-.29 1.556a4.01 4.01 0 0 1 0 4.89.95.95 0 0 0 0 1.11 4.01 4.01 0 0 1 0 4.89.95.95 0 0 0 0 1.11c.704.887 1.558 3.244-.167 3.444-1.34-.049-.75-1.5-1.416-2.22a2.945 2.945 0 0 1 0-3.558 2 2 0 0 0 0-2.443 2.945 2.945 0 0 1 0-3.557 2 2 0 0 0 0-2.443A2.95 2.95 0 0 1 6.18 7H4.456c-.315.451-.71 1.032-.29 1.555a4.01 4.01 0 0 1 0 4.89.94.94 0 0 0 0 1.11 4.01 4.01 0 0 1 0 4.89.94.94 0 0 0 0 1.11C4.871 21.445 5.726 23.8 4 24c-1.329-.037-.758-1.509-1.416-2.222a2.945 2.945 0 0 1 0-3.557 2 2 0 0 0 0-2.443 2.945 2.945 0 0 1 0-3.557 2 2 0 0 0 0-2.443A2.94 2.94 0 0 1 2.164 7H1a1 1 0 0 1 0-2h22a1 1 0 0 1 1 1M1 4c.042.013 22.03-2 22.092-2a1.004 1.004 0 0 0-.183-2L.91 2A1.001 1.001 0 0 0 1 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-noodles_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNoodles;
